import script from "./OrgInsightsDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./OrgInsightsDashboard.vue?vue&type=script&setup=true&lang=js"

import "./OrgInsightsDashboard.vue?vue&type=style&index=0&id=1acb9bce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1acb9bce"]])

export default __exports__